import { render, staticRenderFns } from "./DocumentsDraftTab.vue?vue&type=template&id=31953d10&scoped=true"
import script from "./DocumentsDraftTab.vue?vue&type=script&lang=js"
export * from "./DocumentsDraftTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31953d10",
  null
  
)

export default component.exports